// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"db13490b9a","326":"928f190ce8","784":"f790a221c6","870":"0862a4d2f8"}[chunkId] + ".js";
};